import { AxiosService, OnlineService } from '.';
import { OnlineStatusEnums } from '@/enums/OnlineStatusEnums';
import { ApiEndpoints } from '@/config/index';
import { LoggerService } from '@/utils';
import { AuthStore } from '@/store/store.auth';
import { IQuickGuide, QuickGuide } from '@/models/quickGuide/QuickGuide';

class QuickGuideProvider {
    // tslint:disable-next-line: no-empty
    constructor() {}

    public async FetchQuickGuide(): Promise<IQuickGuide[]> {
        const result: Promise<IQuickGuide[]> = new Promise<IQuickGuide[]>(async (resolve, reject) => {
            if (OnlineService.GetOnlineStatus === OnlineStatusEnums.ONLINE && AuthStore.GetIsLoggedIn === true) {
                await AxiosService.get(ApiEndpoints.quickQuide, null).then((response) => {
                    resolve(response.data.guides as IQuickGuide[]);
                });
            } else {
                LoggerService.LogWarn(`Cant connect to api server, returning wihtout quick guide document`);
                resolve([]);
            }
        });
        return result;
    }
}

export default QuickGuideProvider;
